import React, { useCallback, useState } from "react";
import { Flex, IconButton, Link } from "@radix-ui/themes";
import { ImageIcon, OpenInNewWindowIcon } from "@radix-ui/react-icons";

interface ImageWithActionsProps {
  src: string;
  alt?: string;
  track?: (eventName: string, properties: any) => void;
}

export function ImageWithActions({ src, alt, track }: ImageWithActionsProps) {
  const [failed, setFailed] = useState(false);

  const handleOpenNewTab = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();

      try {
        track?.("cta_button_clicked", {
          entry_page: window.location.pathname,
          link: src,
          chatId: window.quack?.chatSessionId,
          tenant: window.quack?.settings?.tenantId,
          event: "cta_button_clicked",
          action: "open-new-tab",
        });
      } catch (e) {
        // swallow tracking errors
      }

      window.open(src, "_blank", "noopener,noreferrer");
    },
    [src],
  );

  if (!src) return null;

  if (failed) {
    return (
      <Flex gap="1" align="center">
        <ImageIcon />
        <Link href={src} target="_blank" rel="noopener noreferrer" color="gray">
          Image not available
        </Link>
      </Flex>
    );
  }

  return (
    <div className="qc-Chat__Image_Wrapper">
      <img
        src={src}
        alt={alt || "image"}
        style={{
          maxWidth: "100%",
          borderRadius: 8,
          display: "block",
        }}
        onError={() => setFailed(true)}
      />
      <Flex gap="2" className="qc-Chat__Image_Overlay">
        <IconButton variant="surface" color="gray" size="2" onClick={handleOpenNewTab} highContrast>
          <OpenInNewWindowIcon />
        </IconButton>
      </Flex>
    </div>
  );
}
